import { COMMON_ERROR } from 'utils/ErrorMessages'

import { SAVE_AND_TEST_CAMPAIGN_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/constants'
import { SEND_TRY_IT_OUT_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/ReviewAndLaunchStep/constants'

import {
  FETCH_SHARING_EMAILS_ASYNC,
  SET_SHARING_EMAILS_PAGE,
  SHARE_EMAILS_CHANGE,
  SHARE_MESSAGE_CHANGE,
  SHARE_RESET,
  SHARE_RESET_ERROR,
  SHARE_SUBMIT_ASYNC,
} from './constants'

const initialState = {
  message: '',
  selectedProfilesProperties: [],
  profilesProperties: {
    data: {
      items: [],
      meta: {
        count: undefined,
      },
    },
    page: 1,
    loader: false,
  },

  loader: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SHARE_RESET:
      return {
        ...state,
        selectedProfilesProperties: [],
        message: '',
        error: null,
      }
    case SHARE_RESET_ERROR:
      return {
        ...state,
        error: null,
      }
    case FETCH_SHARING_EMAILS_ASYNC.INITIATE:
      return {
        ...state,
        profilesProperties: { ...state.profilesProperties, loader: true },
      }
    case FETCH_SHARING_EMAILS_ASYNC.SUCCESS:
      return {
        ...state,
        profilesProperties: {
          ...state.profilesProperties,
          data:
            state.profilesProperties.page === 1
              ? action.payload.data
              : {
                  items: [...state.profilesProperties.data.items, ...action.payload.data.items],
                  meta: action.payload.data.meta,
                },
          loader: false,
        },
      }
    case SET_SHARING_EMAILS_PAGE:
      return {
        ...state,
        profilesProperties: {
          ...state.profilesProperties,
          page: action.payload.value,
        },
      }
    case SHARE_SUBMIT_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
      }
    case SHARE_SUBMIT_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
      }
    case SHARE_SUBMIT_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        error: COMMON_ERROR,
      }
    case SHARE_EMAILS_CHANGE:
      return {
        ...state,
        selectedProfilesProperties: action.payload.data,
      }
    case SHARE_MESSAGE_CHANGE:
      return {
        ...state,
        message: action.payload.value,
      }

    case SAVE_AND_TEST_CAMPAIGN_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
      }

    case SEND_TRY_IT_OUT_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
      }
    case SEND_TRY_IT_OUT_ASYNC.ERROR:
      return {
        ...state,
        loader: false,
        error: action.error.detail,
      }

    default:
      return state
  }
}
